module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001347.e23e55ff.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001347.pdf
// module id = 344
// module chunks = 0